import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";
import {
  getInvoicecostplusData,
  getloanAdvanceData,
} from "../../../../store/Api";
import { useEffect } from "react";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useState } from "react";
// import EmployeeDetails from "./employeeDetails";
import React from "react";
import nodeinstance from "../../../../nodeInstance";
import PrioritySummaryTable from "./prioritySummaryTable";
import { Link, useLocation } from "react-router-dom";
import EmployeeListTable from "./employeeListTable";
import InvoiceCostPlusSubModule from "./invoiceCostPlusSubmodule";
import GenereteInvoice from "./generateInvoice";
import InvoiceEdit from "./invoiceEdit";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { date } from "yup";
// import EmployeeManager from "./employeemanager";

export default function InvoiceCostPlus() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const titles = [
    "S.NO",
    "FLIGHT DETAILS",
    "COUNTRY",
    "PAX",
    "DATE OF ARRIVAL",
    "TIME OF ARRIVAL",
    "ARRIVAL SECTOR",
    "PICKUP TO BE ARRANGED",
    "PROJECT INCHARGE",
    "AMOUNT REQUEST",
    "FUNDS",
  ];

  const InvoicecostplusData = useSelector((state) => state.Invoicecostplus);

  const [SummaryData, setSummaryData] = useState();

  const [reqDate, setReqDate] = useState();

  function getDate() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    return `${year}-${month}`;
  }

  const InvoicecostPlus = async () => {
    console.log("getDate.......", getDate());
    let newDate = getDate();
    try {
      const response = await nodeinstance.get(
        `/dashboard/invoiceCostPlus/getSummary/${reqDate ? reqDate : newDate}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSummaryData(response?.data);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: "Failed to load the data...",
        })
      );
    }
  };
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(SummaryData?.data);

  useEffect(() => {
    // dispatch(getInvoicecostplusData(token, new Date()));
    InvoicecostPlus();
  }, [reqDate]);

  const [searchWords, setSearchWords] = useState([]);
  console.log("Data to be seen here....fgfh....", currentList);

  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
    routeName: "",
  });
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.split("/")[3] === "generate-invoice") {
      setAddOrEdit((p) => ({
        ...p,
        open: true,
        method: "add",
        routeName: "generateInvoice",
      }));
    } else if (location.pathname.split("/")[3] === "Edit-invoice-batch") {
      setAddOrEdit((p) => ({
        ...p,
        open: true,
        method: "add",
        routeName: "editInvoice",
      }));
    } else {
      setAddOrEdit((p) => ({
        ...p,
        open: true,
        method: "add",
        routeName: "",
      }));
    }
  }, [location]);

  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [client, setClient] = useState([]);

  console.log("selectedCandidates.....selectedCandidates0", selectedCandidates);

  const [invoiceNumber, setInvoiceNumber] = useState();

  const [cancel, setCancel] = useState();

  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "INVOICE COST-PLUS",
          link: "",
        },
      ])
    );
  }, [location]);
  const [delayCount, setDelayCount] = useState();

  console.log("currentList to be printed here........", currentList);

  return (
    <>
      {addOrEdit.routeName === "generateInvoice" ? (
        <GenereteInvoice
          selectedCandidates={selectedCandidates}
          setSelectedCandidates={setSelectedCandidates}
          client={client}
        />
      ) : // <InvoiceEdit selectedCandidates={selectedCandidates} setSelectedCandidates={setSelectedCandidates}  client={client} />
      addOrEdit.routeName === "editInvoice" ? (
        <InvoiceEdit
          setInvoiceNumber={setInvoiceNumber}
          invoiceNumber={invoiceNumber}
          cancel={cancel}
        />
      ) : (
        <>
          <div className="pt-2 uppercase m-3">
            <div className="flex flex-wrap justify-between gap-2 mb-1 items-center">
              <h3 className="ml-4">COST INVOICE PRIORITY SUMMARY: </h3>
              <div className="flex gap-2 ml-auto">
                <Link to="/dashboard/invoice-cost-plus/generate-invoice">
                  <button
                    className="p-2 bg-red text-white rounded-md"
                    style={{ width: "250px" }}
                    disabled={selectedCandidates?.length <= 0}
                  >
                    GENERATE COST INVOICE TABLE
                  </button>
                </Link>
                {/* <button
                  className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                  // onClick={() => downloadFile()}
                  // disabled={downloadLoading}
                >
                  <p>Upload Invoice</p>
                  {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
                {/* </button> */}
              </div>
            </div>
            <div className="ml-4">
              <PrioritySummaryTable
                propData={currentList}
                delayCount={delayCount}
              />
            </div>
          </div>

          <div style={{ width: "100%", height: "300px" }}>
            <EmployeeListTable
              propData={currentList}
              selectedCandidates={selectedCandidates}
              setSelectedCandidates={setSelectedCandidates}
              setClient={setClient}
              setDelayCount={setDelayCount}
              setReqDate={setReqDate}
            />
          </div>
          <div style={{ width: "100%", height: "300px" }}>
            <InvoiceCostPlusSubModule
              propData={currentList}
              setInvoiceNumber={setInvoiceNumber}
              setCancel={setCancel}
            />
          </div>
        </>
      )}
    </>
  );
}
